import { Component } from '@angular/core';

@Component({
  selector: 'mse-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent { }
